import React from "react";

type Props = {
  label: string;
  hint?: string;
  children: React.ReactNode;
};

export default function FormField({ label, hint, children }: Props) {
  return (
    <label className="flex flex-col gap-2 text-sm text-slate-700">
      <span className="text-xs uppercase tracking-[0.2em] text-black/50">
        {label}
      </span>
      {children}
      {hint ? <span className="text-xs text-black/50">{hint}</span> : null}
    </label>
  );
}
